module.exports = __webpack_public_path__ + "img/70.ae9d1b1e.jpg";